import { render } from "./BulkLinks.vue?vue&type=template&id=0a9e27cc"
import script from "./BulkLinks.vue?vue&type=script&lang=js"
export * from "./BulkLinks.vue?vue&type=script&lang=js"

import "./BulkLinks.vue?vue&type=style&index=0&id=0a9e27cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__